import React from 'react'

export default function WaterfallItem(props) {
  const media = props.media
  return (
    <div className="media-wrap">
      <div className="media-media">
        <img src={media.src + "?imageMogr2/thumbnail/600x"} alt={media.title} title={media.title} />
      </div>
      <div className="media-caption">
        <div className="media-title">{media.title}</div>
        <div className="media-description">{media.description}</div>
      </div>
    </div>
  )
}


// WEBPACK FOOTER //
// ./app/javascript/app/site/structures/section/gallery/waterfall/item.js